export default __webpack_public_path__ + "static/media/dash.65839a53.svg";